import React from 'react';
import { List, Edit, Create,
    Datagrid, TextField, BooleanField,
    EditButton, SimpleForm, TextInput, BooleanInput } from 'admin-on-rest';

export const ProfileList = (props) => (
    <List title="All Profiles" {...props}>
        <Datagrid>
            <TextField source="name" />
            <TextField source="ICS" />
            <TextField source="IBAN" />
            <TextField source="BIC" />
            <BooleanField source="batchBooking" />
            <EditButton />
        </Datagrid>
    </List>
);

export const ProfileEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="ICS" />
            <TextInput source="IBAN" />
            <TextInput source="BIC" />
            <BooleanInput source="batchBooking" />
        </SimpleForm>
    </Edit>
);

export const ProfileCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="ICS" />
            <TextInput source="IBAN" />
            <TextInput source="BIC" />
            <BooleanInput source="batchBooking" />
        </SimpleForm>
    </Create>
);


// WEBPACK FOOTER //
// src/resources/profiles.js